import { Component, Input, OnChanges } from '@angular/core';
import { VentaDiaria } from '../../inicio.service';
import { SemanaData } from '../../shared/types';
import { formatShort, formatMoney } from '../../shared/format';
import { calcularSemanas } from '../../shared/metrics';

@Component({
  selector: 'app-metricas-resumen',
  templateUrl: './metricas-resumen.component.html',
  styleUrls: ['./metricas-resumen.component.scss']
})
export class MetricasResumenComponent implements OnChanges {
  @Input() ventasDiarias: VentaDiaria[] = [];
  @Input() ventasAnterior: VentaDiaria[] = [];
  @Input() desde!: Date;
  @Input() hasta!: Date;

  numSemanas = 0;
  totalPesosPeriodo = 0;
  totalKgPeriodo = 0;
  semanaActual: SemanaData = { label: '', totalPesos: 0, totalKg: 0, pct: 0, pctKg: 0 };
  promSemanal = 0;
  promCrecimiento = 0;
  promCrecimientoKg = 0;

  formatShort = formatShort;
  formatMoney = formatMoney;

  ngOnChanges() {
    if (!this.desde || !this.hasta) return;

    // Derivar todo de las MISMAS semanas que muestra el desglose, para que
    // el total cuadre con la suma de las barras semanales.
    const semanas = calcularSemanas(this.ventasDiarias, this.ventasAnterior, this.desde, this.hasta);

    this.numSemanas = semanas.length;
    this.totalPesosPeriodo = semanas.reduce((s, w) => s + w.totalPesos, 0);
    this.totalKgPeriodo = semanas.reduce((s, w) => s + w.totalKg, 0);
    this.semanaActual = semanas[0] ?? { label: '', totalPesos: 0, totalKg: 0, pct: 0, pctKg: 0 };
    this.promSemanal = this.numSemanas ? this.totalPesosPeriodo / this.numSemanas : 0;

    const prom = (campo: 'pct' | 'pctKg') => {
      const crecs = semanas.map(w => w[campo]).filter(p => p !== 0);
      return crecs.length ? Math.round(crecs.reduce((a, b) => a + b, 0) / crecs.length) : 0;
    };
    this.promCrecimiento = prom('pct');
    this.promCrecimientoKg = prom('pctKg');
  }
}
